import React from 'react';
import { Hero } from '../components/Hero';
import { Advantages } from '../components/Advantages';
import { Services } from '../components/Services';
import { Gallery } from '../components/Gallery';
import { Courses } from '../components/Courses';
import { About } from '../components/About';
import { Reviews } from '../components/Reviews';
import { CTA } from '../components/CTA';
export function Home() {
  return <main data-id="element-561">
      <Hero data-id="element-562" />
      <Advantages data-id="element-563" />
      <Services data-id="element-564" />
      <Gallery data-id="element-565" />
      <Courses data-id="element-566" />
      <About data-id="element-567" />
      <Reviews data-id="element-568" />
      <CTA data-id="element-569" />
    </main>;
}